import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { EdTreatmentService } from '@services/ed-treatment.service';
import { NavigationService } from '@services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class EdTreatmentGuard implements CanActivate {
  private readonly edTreatmentService = inject(EdTreatmentService);
  private readonly router = inject(Router);
  private readonly navigationService = inject(NavigationService);

  /**
   * Determines whether the ED treatment upsell page can be activated.
   *
   * @param {ActivatedRouteSnapshot} _route the activated route snapshot (unused)
   * @param {RouterStateSnapshot} state the router state snapshot
   *
   * @returns {boolean | UrlTree} true to allow navigation, or a UrlTree to redirect to the next page
   */
  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.edTreatmentService.shouldOfferUpsell()) {
      return this.router.createUrlTree([this.navigationService.getNextNavigationUrl(state.url)]);
    }

    return true;
  }
}
